import React, { useEffect, useState } from "react";
import Layout from "../../../Layouts";
import { Row, Col, Badge, Select, Checkbox, Tabs, Modal } from "antd";
import ProgressBar from "@ramonak/react-progress-bar";
import { IoLocation } from "react-icons/io5";
import { FaHospital } from "react-icons/fa";
import Vitals from "./ConfiguredVitals";
import { RiEditFill } from "react-icons/ri";
import Careplan from "./Careplan";
import Alerts from "./Alerts";
import Devices from "./MappedDevices";
import Summary from "./Summary";
import { useDispatch, useSelector } from "react-redux";
import MedicalHistory from "./MedicalHistory";
import MedicalRecord from "./MedicalRecords";
import ClinicalNotes from "./ClinicalNotes";
import ActivityReport from "./ActivityReport";
import ReviewStatus from "./ReviewPallette";
import AddPatient from "../AddNewPatient";
import { setSelectedRpmPatient } from "../../../../Redux/actions/rpmActions";
import {
  fetchPatients,
  fetchPatientsCount,
  setSelectedEditPatient,
} from "../../../../Redux/actions/patientActions";

const PatientPallet = () => {
  const [detailedView, setDetailedView] = useState(false);
  const selectedRpmPatient = useSelector(
    (state) => state?.rpm?.selectedRpmPatient,
  );
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const dummyICDs = ["Diabetes", "Hypertension", "Asthma"];

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      if (rpmPatientJson) {
        try {
          const rpmPatientObject = JSON.parse(rpmPatientJson);
          if (rpmPatientObject) {
            dispatch(setSelectedRpmPatient(rpmPatientObject));
          }
        } catch (err) {
          console.error("Error parsing rpmPatient from session storage", err);
        }
      }
    }
  }, [selectedRpmPatient, dispatch]);

  if (!selectedRpmPatient) {
    return <div>Loading patient data...</div>;
  }

  const dummyOptions = [
    { value: "not allocated", label: "Not Allocated" },
    { value: "inprogress", label: "In Progress" },
    { value: "completed", label: "Completed" },
  ];

  const items = [
    {
      key: "1",
      label: `Vitals`,
      children: <Vitals />,
    },
    {
      key: "2",
      label: `Care Plan`,
      children: <Careplan />,
    },
    {
      key: "3",
      label: `Alerts`,
      children: <Alerts />,
    },
    {
      key: "4",
      label: `Devices`,
      children: <Devices />,
    },
    {
      key: "5",
      label: `Summary`,
      children: <Summary />,
    },
  ];

  const handleCancel = () => {
    setDetailedView(false);
  };

  const handleSave = async () => {
    setDetailedView(false);
    const patientPayload = {
      account_Id: loggedUser.user.account_Id,
      clinic_Id: loggedUser.user.clinic_Id,
      pageNo: 1,
    };

    dispatch(fetchPatients(patientPayload));
    dispatch(fetchPatientsCount(patientPayload));
  };

  const handleEditPatient = () => {
    setDetailedView(true);
    dispatch(setSelectedEditPatient(selectedRpmPatient));
  };

  const clinicalStatus = () => {
    const status =
      selectedRpmPatient?.clinicalStatus === 0
        ? "Normal"
        : selectedRpmPatient?.clinicalStatus === 1
          ? "Abnormal"
          : selectedRpmPatient?.clinicalStatus === 2
            ? "Critical"
            : "";
    return status;
  };

  const clinicalStatusBadgeColur = () => {
    const status =
      selectedRpmPatient?.clinicalStatus === 0
        ? "#00BB4B"
        : selectedRpmPatient?.clinicalStatus === 1
          ? "#FFAA00"
          : selectedRpmPatient?.clinicalStatus === 2
            ? "#FF3411"
            : "";
    return status;
  };

  return (
    <Layout>
      <div className="mb-5 p-3">
        <div>
          <Row className="w-full" gutter={[0, 16]}>
            <Col xs={24} md={18}>
              <Badge.Ribbon
                className={` bg-[${clinicalStatusBadgeColur()}]`}
                text={clinicalStatus()}
                style={{
                  right: "5px",
                  backgroundColor: `${clinicalStatusBadgeColur()}`,
                }}
              >
                <div className="bg-white rounded-lg p-3 mr-0 md:mr-5 border">
                  <Row gutter={[20, 16]}>
                    <Col xs={24} md={8}>
                      <div
                        className="border-dashed border-gray-300 h-full pb-4 md:pb-0 border-b md:border-b-0 md:border-r-[3px]"
                      >
                        <div className="flex items-center">
                          <div
                            onClick={handleEditPatient}
                            className="h-20 w-20 md:h-24 md:w-24 border-2 p-3 md:p-4 rounded-full cursor-pointer relative flex-shrink-0"
                          >
                            <img
                              src={
                                process.env.REACT_APP_IMAGE_URL +
                                (selectedRpmPatient?.photoName ||
                                  selectedRpmPatient?.imageName) +
                                `?t=${Date.now()}`
                              }
                              alt={selectedRpmPatient?.firstName}
                              className={`absolute top-0 left-0 w-full h-full object-fill rounded-full`}
                            />
                          </div>
                          <div className=" ml-5 min-w-0">
                            <div className="text-black xl:text-base lg:text-sm md:text-sm text-xs font-bold pb-2 truncate">
                              {selectedRpmPatient?.salutation}
                              {selectedRpmPatient?.firstName +
                                " " +
                                selectedRpmPatient?.lastName}
                            </div>
                            <div className="text-gray-500 text-xs font-montserrat font-medium pb-2 space-y-2">
                              <p>{selectedRpmPatient?.patientId} |</p>
                              <p>
                                {selectedRpmPatient?.dob} {` `}
                                {selectedRpmPatient?.gender === "F"
                                  ? "Female"
                                  : selectedRpmPatient?.gender === "M"
                                    ? "Male"
                                    : "NA"}
                              </p>
                            </div>
                            <div className="text-black text-sm font-sans font-medium pb-2">
                              Program:
                              <span className="text-gray-500 font-montserrat text-sm font-medium pl-1">
                                {selectedRpmPatient?.rpmApplicable === "Y"
                                  ? "RPM"
                                  : ""}
                              </span>
                            </div>
                            <div className="text-black text-sm font-sans font-medium pb-2">
                              Preferred Language:
                              <span className="text-gray-500 font-medium text-sm font-montserrat pl-2">
                                English
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col xs={24} md={6}>
                      <div
                        className="border-dashed border-gray-300 h-full pb-4 md:pb-0 border-b md:border-b-0 md:border-r-[3px]"
                      >
                        <div className="text-black text-sm font-sans font-medium pb-2">
                          Provider:
                          <span className="text-gray-500 font-medium text-sm font-montserrat pl-2">
                            {selectedRpmPatient?.providerName}
                          </span>
                        </div>
                        {/* <div className="text-black text-sm font-medium font-montserrat pb-2">
                        CareTeam:
                        <span className="text-gray-500 xl:text-sm text-xs font-sans font-semibold pl-2">-</span>
                      </div> */}
                        <div className="flex items-center mt-1">
                          <div className="text-gray-500 xl:text-sm text-xs font-medium font-montserrat pl-2 flex gap-2 items-center">
                            <IoLocation className="w-4 h-4 text-teal-500" />
                            {selectedRpmPatient?.city}
                          </div>
                        </div>
                        <div className="flex items-center mt-3">
                          <div className="text-gray-500 xl:text-sm text-xs font-medium font-montserrat pl-2 flex gap-2 items-center">
                            <FaHospital className="w-4 h-4 text-teal-500" />
                            {selectedRpmPatient?.hospitalName}
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={5}>
                      <div
                        className="border-dashed border-gray-300 h-full pb-4 md:pb-0 border-b md:border-b-0 md:border-r-[3px]"
                      >
                        <div className="text-black text-base font-sans font-semibold pb-2">
                          Conditions:
                        </div>
                        <div className="h-32 overflow-auto">
                          <ul className="text-gray-500 text-sm font-medium font-mono list-decimal ml-4">
                            {selectedRpmPatient?.patientChronicConditionsList ===
                            0 ? (
                              <>&nbsp;</>
                            ) : (
                              selectedRpmPatient?.patientChronicConditionsList?.map(
                                (item, index) => (
                                  <li key={index} className="mb-1">
                                    {item.chronicDescription}
                                  </li>
                                ),
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    </Col>

                    <Col xs={24} sm={12} md={5}>
                      <ReviewStatus />
                    </Col>
                  </Row>
                </div>
              </Badge.Ribbon>
            </Col>

            <Col xs={24} md={6}>
              <ActivityReport />
            </Col>
          </Row>
          <Row className="w-full mt-5" gutter={[0, 16]}>
            {/* Left: Tabs */}
            <Col xs={24} md={18} className="summaryFull">
              <div className="bg-white rounded-lg px-3 mr-0 md:mr-5 border h-[560px] md:h-[900px] overflow-y-scroll scrollWidth">
                <Tabs
                  defaultActiveKey="1"
                  items={items}
                  className="patient-tab"
                  destroyInactiveTabPane={true}
                />
              </div>
            </Col>

            <Col xs={24} md={6}>
              {/* Medical history */}
              <MedicalHistory />

              <br />

              {/* Clinical Notes */}
              <ClinicalNotes />
              <br />

              {/* Medical records */}
              <MedicalRecord />
            </Col>
          </Row>
        </div>

        {/* Patient View and edit */}
        <Modal
          title={
            <h2 className="md:text-2xl text-lg font-bold">Patient Details</h2>
          }
          width={"80%"}
          className="responsive-modal"
          open={detailedView}
          footer={[]}
          onCancel={handleCancel}
          destroyOnClose
        >
          {/* <PatientViewAndEdit currSelected={selectedPatient} handleCancel={handleCancel} handleSave={handleSave} handlePatientEdit={handlePatientEdit} editEnabled={editEnabled} /> */}
          <AddPatient handleCancel={handleCancel} handleSave={handleSave} />
        </Modal>
      </div>
    </Layout>
  );
};

export default PatientPallet;